const image = {
  src: 'https://stgimages.christies.com/img/SaleImages/CKS-16310-07052018-1.jpg',
  alt: 'Georges Mathieu (1921-2012)',
}

export default [
  {
    image: image,
    primaryTitle: 'Fashion photography',
    date: '15-17 Dec',
    type: 'Online auction',
    location: 'Online',
    url: 'https://christies.com/',
  },
  {
    image: image,
    primaryTitle: 'Susanne von Meiss collection',
    date: '21-30 Dec',
    type: 'Online auction',
    location: 'Online',
    url: 'https://christies.com/',
  },
  {
    image: image,
    primaryTitle: 'Photography & architecture',
    date: '14 Dec',
    type: 'Live auction',
    location: 'New York',
    url: 'https://christies.com/',
  },
]
